import Component from '../../../shared/component';

const SCROLL_TRIGGER_OFFSET = 400;
const FILL_VIEWPORT_DELAY_IN_MS = 1000;

export default class GroupMessages extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$contentElement = $('.groupWindow-content');
    this.$contentInnerElement = this.$contentElement.find(
      '.groupWindow-content-inner'
    );

    this.isFetchingPreviousMessages = false;
    this.shouldFetchPreviousMessages = true;

    this.fillViewport();
    this.bindEvents();
  }

  bindEvents() {
    this.handleScroll = this.handleScroll.bind(this);

    this.$contentElement.on('scroll.GroupMessages', this.handleScroll);
  }

  unbindEvents() {
    this.$contentElement.off('scroll.GroupMessages', this.handleScroll);
  }

  fetchPreviousMessages() {
    this.isFetchingPreviousMessages = true;

    const $lastMessageElement = this.$element
      .find('.groupMessages-item')
      .last();

    if ($lastMessageElement.length) {
      const until = $lastMessageElement.data('last-activity-at');

      $.get(this.$element.attr('action'), {until}).done((data) =>
        this.handlePreviousMessagesSuccess(data)
      );
    } else {
      this.isFetchingPreviousMessages = false;
    }
  }

  appendPreviousMessages(html) {
    this.$element.append(html);
  }

  fillViewport() {
    setTimeout(() => {
      // If the handleScroll returns true, it means that
      // we just fetched new messages. It also means that we must
      // continue to call handleScroll until the viewport is filled
      if (this.handleScroll()) this.fillViewport();
    }, FILL_VIEWPORT_DELAY_IN_MS);
  }

  handleScroll() {
    if (this.shouldFetchPreviousMessages && !this.isFetchingPreviousMessages) {
      const scrollPosition =
        this.$contentElement.scrollTop() + this.$contentElement.height();
      const maxScroll =
        this.$contentInnerElement.height() - SCROLL_TRIGGER_OFFSET;

      if (scrollPosition > maxScroll) {
        this.fetchPreviousMessages();
        return true;
      }
    }
  }

  handlePreviousMessagesSuccess(data) {
    if (String(data).trim() !== '') {
      this.appendPreviousMessages(data);
    } else {
      // We’ve reached the bottom of the list, stop trying to fetch messages
      this.shouldFetchPreviousMessages = false;
    }

    this.isFetchingPreviousMessages = false;
  }
}
